/**
 * Media Engine Api
 * @module api/mediaEngine
 */

import Settings from '../settings';

export const submitJob = (data) =>
  fetch(`${Settings.serverPath}PublishingHandler.ashx`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify({ ...data }),
    dataType: 'json'
  })
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return { ok: false };
    })
    .then(response => Promise.resolve(response))
    .catch(error => console.log(error));



// WEBPACK FOOTER //
// ./app/api/mediaEngine.js